import { Component, OnInit, ElementRef, ViewChild, Input, EventEmitter, HostListener, Renderer2, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';

import { BehaviorSubject, Subscription } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'side-banner',
  templateUrl: '../sharedTemplates/side-banner.component.html',
})
export class SideBanner implements OnInit, OnDestroy {
  @Input()
  _sideBannerData;

  @Input()
  _sblocationid: number;

  _newSideBannerList;

  private subscriptionsToStopOnDestroy: Subscription[] = [];
  constructor(
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    private _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    public _LocalizationService: LocalizationService,
    public _LZ: LocalizationService,
    private cdRef: ChangeDetectorRef,
    private _SignalRService: SignalrServiceLegacy
  ) {}
  ngOnInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.sideBannerDataListener.subscribe(x => {
        // //console.log("--this._newSideBannerList-XXX-",x)
        this._newSideBannerList = x.filter(y => y.PositionId === this._sblocationid);
        // //console.log("--this._newSideBannerList--",this._newSideBannerList)
      })
    );
    // console.warn("_newSideBannerList ",this._newSideBannerList,this._LocalizationService.LANGCODE )
  }

  goToLink(e: string) {
    try {
      if (e.includes('http')) {
        window.location.href = e;
      } else {
        window.location.href = window.location.origin + e;
      }
    } catch (e) {
      console.log(e);
    }
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }
}
